import Chip from '@shared/components/chips';
import ItemSection from '@shared/components/sections/item-section';
import { html } from '@shared/utils/rendering/html';
import { hasEscapeCharacters, formatTextToHtmlSafe } from '@shared/utils/rendering/text-formatter';
import NoSectionResults from '@shared/components/sections/no-section-results';
import SubcomponentSection from '../subcomponents/subcomponent-section';
import { useEffect } from 'preact/hooks';
import { ComponentStatusFromId } from '../../../../../constants/chips/component-status.constants';
import { calculateComponentStatus } from '../helpers/component-status';

const ComponentSection = ({ details, filters, filterRef }) => {
    const subcomponentsForStatus = details.originalSubcomponents || details.subcomponents;
    const chipDetails = ComponentStatusFromId(calculateComponentStatus(subcomponentsForStatus));

    return html`
        <${ItemSection}
            key=${details.id}
            title=${{
                precedent: html`<${Chip}
                    label=${chipDetails.label}
                    type="status-chip"
                    css="${chipDetails.css} me-1"
                />`,
                text: details?.name,
            }}
            id="item-section-${details.id}"
            startOpen=${false}>

            <div class="section-description">
                ${
                    hasEscapeCharacters(details.description)
                        ? html`<p
                              dangerouslySetInnerHTML=${formatTextToHtmlSafe(details.description)}
                          ></p>`
                        : html`<p>${details.description}</p>`
                }
            </div>

            <${SubcomponentSection} details=${details} filterRef=${filterRef} filters=${filters} isSecondPeriod=${
                filters?.isSecondPeriod
            } />

        </${ItemSection}>
    `;
};

export default ComponentSection;
